/**
 * @module "ethpm/installer"
 */

export * from './service';
